import { render, staticRenderFns } from "./NotificationRefreshBall.vue?vue&type=template&id=04d859fc&scoped=true&"
var script = {}
import style0 from "./NotificationRefreshBall.vue?vue&type=style&index=0&id=04d859fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d859fc",
  null
  
)

export default component.exports